import { render } from "./NotFoundComponent.vue?vue&type=template&id=51203426&scoped=true"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"

import "./NotFoundComponent.vue?vue&type=style&index=0&id=51203426&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51203426"]])

export default __exports__